import { createAction, props } from '@ngrx/store';
import { Pagination } from '../models/pagination.model';
import { Invitation } from '../models/invitation.model';

export const setHistoryInvitations = createAction('[History Invitations Component] setHistoryInvitations', props<Pagination<Invitation>>());

export const resetHistoryInvitations = createAction('[History Invitations Component] ResetHistoryInvitations');
